import createSymbol from '../createSymbol';
export var REQUEST_SAGA = createSymbol('request-saga');